import { render, staticRenderFns } from "./BornPeriodDesc.vue?vue&type=template&id=1bef3cf4&"
import script from "./BornPeriodDesc.vue?vue&type=script&lang=js&"
export * from "./BornPeriodDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports